// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ButtonCta_wrapper__iBag2"};